$(document).ready(() => {
	const swiper = $('.swiper-container');

	if (swiper.length) {
		new Swiper('.swiper-container', {
			slidesPerView: 1,
			spaceBetween: 10,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 23,
				},
				1025: {
					slidesPerView: 4,
					spaceBetween: 23,
				},
			}
		})
	}
});
